<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<h1 class="•-CH-NUM-8-4-2015" id="_idParaDest-1"><span class="CharOverride-1"><a id="_idTextAnchor000"></a>The Wright Stuff:</span></h1>
<h1 class="•-CH-NUM-8-4-2015PMOD"><span class="CharOverride-2">From NBC to Autism Speaks</span></h1><br/><br/>
<h1 class="•-CH-NUM-8-4-2015"><span class="CharOverride-3">Bob Wright</span></h1>
<h1 class="•-CH-NUM-8-4-2015PMOD"><span class="CharOverride-4">with Diane Mermigas</span><br/><br/></h1>
</div>
<div class="_idGenObjectLayout-1PMOD">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1PMOD" src="image/_RosettaBooks_Logo.png"/>
<p class="•-CH-TITLE-8-4-2015PMOD" id="_idParaDest-2"><span class="CharOverride-5"><a id="_idTextAnchor001"></a>New York, 2016</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_-_test.vue?d87214fe